/**
 * Canonical SSAP data inconsistency rule IDs.
 * Add new rule IDs here as checks are implemented in ssapDataInconsistencyRules.js.
 */
export const SSAP_DATA_INCONSISTENCY_RULE_IDS = {
    INCOME_AMOUNT_WITHOUT_FREQUENCY: 'INCOME_AMOUNT_WITHOUT_FREQUENCY',
    HHM_INCOME_PARAMS_NOT_POPULATED: 'HHM_INCOME_PARAMS_NOT_POPULATED',
};

/**
 * Rule IDs enabled for on-the-fly checks (developer environments only).
 */
export const ENABLED_SSAP_DATA_INCONSISTENCY_RULE_IDS = [
    SSAP_DATA_INCONSISTENCY_RULE_IDS.INCOME_AMOUNT_WITHOUT_FREQUENCY,
    SSAP_DATA_INCONSISTENCY_RULE_IDS.HHM_INCOME_PARAMS_NOT_POPULATED,
];
